import type { ComponentPropsWithRef } from "react";
import { forwardRef } from "react";
import classNames from "classnames";
import { TextRenderer } from "@/react/components/shared/BuilderUI/DefaultBlocks/Content/RichText/TextRenderer";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { parseStyles } from "@circle-react-shared/BuilderUI/utils/parseStyles";
import { defaultStyles } from "./defaultStyles";

interface H5Props extends ComponentPropsWithRef<"h5"> {
  blockPath: string;
  styles: Record<string, StyleValue>;
  text: string;
}

export const H5 = forwardRef<HTMLHeadingElement, H5Props>(
  ({ text, blockPath, styles, className, ...rest }, ref) => {
    const inlineStyles = parseStyles({ styles, defaultStyles });

    return (
      <h5
        ref={ref}
        className={classNames(
          "wb-text-h5-color wb-text-h5 wb-font-h5 wb-leading-h5 wb-tracking-h5 wb-normal-case wb-whitespace-pre-wrap",
          className,
        )}
        style={inlineStyles}
        data-testid="builder-heading"
        {...rest}
      >
        <TextRenderer blockPath={blockPath} text={text} />
      </h5>
    );
  },
);

H5.displayName = "H5";
